enum PaymentMethod {
  Cash = 'Cash',
  Website = 'Website',
  PayPal = 'PayPal',
  Venmo = 'Venmo',
  Other = 'Other',
}

export default PaymentMethod
